import React from 'react';
import { i18n } from 'core/localization';
import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { AuthenticationFormConfig, AuthenticationFormFooterProps } from 'areas/administration/authentication/types';
import { AuthenticationFormFooter } from './authentication-form-footer/authenticationFormFooter';
import { AuthenticationForm } from './authenticationForm';
import { AuthenticationFormStore } from './authenticationFormStore';

export const openAuthenticationForm = async (config: AuthenticationFormConfig) => {
	const store = new AuthenticationFormStore(config);

	const modal = openModal(
		() => ({
			title: store.isCreate ? (config.title ?? i18n('Create authentication')) : i18n('Authentication details'),
			mode: store.isCreate ? 'create' : 'update',
			width: 520,
			resizable: false,
			positionType: ModalPosition.Centered,
			mask: { closable: false },
			okButtonProps: { disabled: store.okDisabled, loading: store.saving },
			footer: (_: React.ReactNode, extra: AuthenticationFormFooterProps['extra']) => (
				<AuthenticationFormFooter store={store} extra={extra} />
			),
			onOk: async (e) => {
				e.preventDefault();
				if (await store.save()) {
					modal.close(true);
					config.onClose?.();
					store.destroy();
				}
			},
			onCancel: () => {
				config.onClose?.();
				store.destroy();
			},
		}),
		<AuthenticationForm store={store} />,
	);

	const loaded = await store.load();
	if (!loaded) {
		modal.close();
		config.onClose?.();
		store.destroy();
	}

	return modal;
};
